"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Icon_1 = __importDefault(require("../Icon"));
var Link_1 = __importDefault(require("../Link"));
var FullLogo = (0, styled_1.default)(Link_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'none'
        },
        _b[theme.mediaQueries.lg] = {
            display: 'block'
        },
        _b);
});
var Logo = (0, styled_1.default)(Link_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'block'
        },
        _b[theme.mediaQueries.lg] = {
            display: 'none'
        },
        _b);
});
function ResponsiveLogo(props) {
    var iconColor = props.colorTheme === 'DARK' ? 'white' : 'black';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FullLogo, { href: "/" },
            react_1.default.createElement(Icon_1.default, { name: "ff-icon-logo-full-black", fontSize: '32px', color: iconColor, display: 'block' })),
        react_1.default.createElement(Logo, { href: "/" },
            react_1.default.createElement(Icon_1.default, { name: "ff-icon-logo", fontSize: { _: '23px', md: '32px' }, color: iconColor, display: 'block' }))));
}
exports.default = ResponsiveLogo;
